import React, { FC } from 'react'

import styled from 'styled-components'

import { Icon } from 'src/components/atoms'

const Circle = styled.div`
  width: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  position: absolute;
  top: -2px;
  left: -2px;
`

type Props = {
  searchEnabled: boolean
  className?: string
}

export const SearchRefinementIcon: FC<Props> = ({ searchEnabled, className }) => {
  return (
    <div className={className}>
      <div className="tw-relative">
        {searchEnabled && <Circle className="tw-bg-correctGreen-default" />}
        <Icon
          size="--r0"
          path={searchEnabled ? 'filter/soft/fill' : 'filter/soft/line'}
          className={
            searchEnabled ? 'tw-text-standardText-secondary' : 'tw-text-standardText-disable'
          }
        />
      </div>
    </div>
  )
}
